import { render, staticRenderFns } from "./match.vue?vue&type=template&id=c4973e12&scoped=true&"
import script from "./match.vue?vue&type=script&lang=js&"
export * from "./match.vue?vue&type=script&lang=js&"
import style0 from "./match.vue?vue&type=style&index=0&id=c4973e12&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4973e12",
  null
  
)

export default component.exports